import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { AddOrEditActivityData } from '@app/shared/components/dialogs/add-or-edit-activity-dialog/add-or-edit-activity-dialog.data';
import { cmsActions } from '@src/store/reducers/cmsReducer';

@Component({
    selector : 'add-or-edit-activity-dialog',
    template: require('./add-or-edit-activity-dialog.component.html'),
    styles: [require('./add-or-edit-activity-dialog.component.scss')]
})
export class AddOrEditActivityComponent {
     activityName : string;
     textName : string;
     activityResult : any;
     unSubscribe :any
     projectId : any
     public textActivity: string
    constructor(@Inject(MAT_DIALOG_DATA) public data: AddOrEditActivityData ) {
        this.projectId = data.projectId
        data.store.dispatch({ type: cmsActions.GET_ALL_JIRA_CMS_TASKS_QUERYS, payload: { projectId: this.projectId } });
        if(data.activity && data.name == 'Query'){
            this.activityName = data.activity.name;
            this.activityResult =  data.activity.test
            data.activity.text = (data.activity.text) ? data.activity.text : this.getValueByCMSType(data)
        }
        else if(data.activity && data.name == 'Activity'){
            this.activityName = data.activity.name;
            this.textActivity = data.activity.text
        }
    }

    getValueByCMSType(data) {
        if (this.data.store.getState().projects.projectWithMetaData.connectedCmsProject.cmsTypeName == "JIRA") {
            data.tooltip = 'HELP_JQL_QUERY_TOOLTIP'
            return 'project = \'{cms project name}\''
        }
        else if (this.data.store.getState().projects.projectWithMetaData.connectedCmsProject.cmsTypeName == "ServiceNow") {       
            data.tooltip = 'HELP_SERVICE_NOW_TOOLTIP'
            return 'board.name = {cms project name}'
        }
    }

    onDialogTestCMSCon(data){
        let localCheckTest = true;
        let projectId = this.projectId
        this.unSubscribe = this.data.store.subscribe(_ => {
            if (this.data.store.getState().cmss && this.data.store.getState().cmss.test && localCheckTest) {
                localCheckTest = false;
                data.test = this.data.store.getState().cmss.test;
                this.unSubscribe();
            }
        });
        if (!data.text) {
            data.text = '';
        }
        this.data.store.dispatch({ type: cmsActions.TEST_JIRA_QUERY_TASK_CONNECTION, payload: {projectId ,...data } });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/add-or-edit-activity-dialog/add-or-edit-activity-dialog.component.ts